import { ColumnDef } from '@tanstack/react-table'

import { Category } from '@/interfaces/containerCategory'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline'
import { Dispatch, SetStateAction } from 'react'
import { formatDateForTableSeparatedDateAndTime } from '@/utils/helpers'

export const getColumns = (
  setShowEditCategory: Dispatch<SetStateAction<boolean>>,
  setCategoryToEdit: Dispatch<SetStateAction<Category | undefined>>,
  setShowDeleteCategory: Dispatch<SetStateAction<boolean>>,
  setCategoryToDelete: Dispatch<SetStateAction<number | undefined>>
) => {
  const columns: ColumnDef<Category>[] = [
    {
      accessorKey: 'name',
      header: 'Nombre',
      cell: ({ row }) => {
        const name = row.original?.name || ''
        return <span>{`${name}`.trim()}</span>
      },
      enableHiding: false, // Important column, don't allow hiding
    },
    {
      accessorKey: 'description',
      header: 'Descripción',
      cell: ({ row }) => {
        const observations = row.original?.description || ''
        return <span>{`${observations}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    {
      accessorKey: 'createdAt',
      header: 'Fecha de creación',
      cell: ({ row }) => {
        const { date, time } = formatDateForTableSeparatedDateAndTime(
          row.original?.createdAt
        )
        return (
          <div className="flex flex-col items-start">
            <span>{date}</span>
            <span>{time}</span>
          </div>
        )
      },
    },
    {
      accessorKey: 'actions',
      header: 'Acciones',
      cell: ({ row }) => {
        const { id, name, description, createdAt } = row.original
        return (
          <div className={'flex justify-start'}>
            <div role={'button'} className={`p-2`} onClick={() => {}}>
              <PencilSquareIcon
                className={`h-5 w-5 text-blue-700`}
                onClick={() => {
                  setShowEditCategory(true)
                  setCategoryToEdit({ id, name, description, createdAt })
                }}
              />
            </div>

            <div role={'button'} className={`p-2`} onClick={() => {}}>
              <TrashIcon
                className={`h-5 w-5 text-red-700`}
                onClick={() => {
                  setShowDeleteCategory(true)
                  setCategoryToDelete(id)
                }}
              />
            </div>
          </div>
        )
      },
    },
  ]

  return columns
}
